import { useSelector } from 'react-redux';
import { RootState } from '../../stores';
import { User } from '../../models/auth';
import useTranslation from '../../hooks/TranslationContext';
import { useState } from 'react';
import { getAvatarColor, getInitials } from '../../helpers/objectHelper';
import { getDayName, getFormatDateWithDay } from '../../helpers/dateHelper';
import { DestinationResolverModel } from '../../models/destinationResolver';
import { Popover } from 'antd';

// defines
type Props = {
  className?: string,
  onProfileClick: () => void,
  onLogoutClick: () => void;
}

export default function PortalMobileHeaderMenu({ className, onProfileClick, onLogoutClick }: Props) {
  const { t, changeLanguage, language } = useTranslation();
  const user = useSelector((state: RootState) => state.user.currentUser) as User;
  const destinationResolver = useSelector((state: RootState) => state.user.destinationResolver) || new DestinationResolverModel();

  const [open, setOpen] = useState(false);

  const onOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const onProfileClickHandler = () => {
    onOpenChange(false);
    onProfileClick?.();
  }

  const renderProfilePopoverContect = () => (
    <>
      {/* Profile Info */}
      <div className="p-4 text-center" onClick={onProfileClickHandler}>
        <div className="w-20 h-20 rounded-full mx-auto mb-3 flex items-center justify-center"
          style={{ backgroundColor: getAvatarColor(user?.firstName) }}>
          <span className="text-white text-2xl font-medium">
            {getInitials(user?.firstName)}
          </span>
        </div>
        <h3 className="text-lg font-semibold text-gray-200">
          {user?.firstName} {user?.lastName}
        </h3>
        <p className="text-sm text-gray-300 mt-1">
          {destinationResolver.displayName}
        </p>
      </div>

      {/* Date Display */}
      <div className="py-3 text-center border-t border-gray-600">
        <p className="text-sm text-gray-400">{getDayName()}</p>
        <p className="text-sm text-gray-400">{getFormatDateWithDay(language)}</p>
      </div>

      {/* Logout Button */}
      <button
        className="w-full mt-4 py-2 bg-red-600 rounded-lg text-white flex items-center justify-center gap-2"
        onClick={onLogoutClick}
      >
        <span className="text-lg">⎋</span>
        <span>{t('log-out')}</span>
      </button>
    </>
  )

  return (
    <header className={`${className} bg-gray-800 text-white p-4`}>
      {/* Top Bar with Language and Logout */}
      <div className="flex justify-between items-center mb-4">
        {/* Language Switcher */}
        <button
          className="text-sm p-2 border rounded"
          onClick={() => changeLanguage(language === "en" ? "fa" : "en")}
        >
          {language === "en" ? "🇮🇷 فارسی" : "🇺🇸 English"}
        </button>

        {/* Profile Toggle Button */}

        <Popover
          content={renderProfilePopoverContect}
          trigger="click"
          open={open}
          color="#374151"
          onOpenChange={onOpenChange}
        >
          <button
            className="flex items-center gap-2"
          >
            <div className="w-8 h-8 rounded-full flex items-center justify-center"
              style={{ backgroundColor: getAvatarColor(user?.firstName) }}>
              <span className="text-white font-medium">
                {getInitials(user?.firstName)}
              </span>
            </div>
          </button>
        </Popover>
      </div>
    </header>
  )
};
